<!--  -->
<template>
  <div class="container">
    <div class="top">
      <span class="hint">请选择发票类型</span>
      <span class="status">待开票</span>
    </div>
    <div class="type">
      <div class="putong" :class="0 == selectType?'light':''" @click="select(0)">
        <p class="text_one">普通发票</p>
        <p class="text_two">普通发票快速申请</p>
      </div>
      <div class="zhuanyong" :class="1 == selectType?'light':''" @click="select(1)">
        <p class="text_one">专用发票</p>
        <p class="text_two">增值税专用发票</p>
      </div>
    </div>
    <p class="ticketHint">发票具有同等法律效力, 可支持报销入账</p>
    <div class="hint_two">发票详情</div>
    <div class="box" v-show="selectType == 0">
      <div class="item">
        <span class="star">*</span>
        <span class="title">抬头类型</span>
        <input
          type="radio"
          class="radio"
          v-model="selectStatus"
          value="企业"
          id="company"
          name="company"
          @click="selectStatus='企业'"
        />
        <label class="radio_one" for="company">企业</label>
        <input
          type="radio"
          class="radio"
          v-model="selectStatus"
          id="user"
          value="个人"
          name="user"
          @click="selectStatus='个人'"
        />
        <label class="radio_two" for="user">个人/非企业单位</label>
      </div>
      <div class="item" v-show="selectStatus == '企业'">
        <span class="star">*</span>
        <span class="title">企业名称</span>
        <input type="text" placeholder="请输入企业名称" v-model="param.bill_to" />
      </div>
      <div class="item" v-show="selectStatus == '企业'">
        <span class="star">*</span>
        <span class="title">联系人</span>
        <input type="text" placeholder="请输入学员姓名" v-model="param.bill_to" />
      </div>
      <div class="item" v-show="selectStatus == '个人'">
        <span class="star">*</span>
        <span class="title">学员姓名</span>
        <input type="text" placeholder="请输入学员姓名" v-model="param.bill_to" />
      </div>
      <div class="item" v-show="selectStatus == '企业'">
        <span class="star">*</span>
        <span class="title">税号</span>
        <input type="text" placeholder="请输入税号" v-model="param.tfn" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">联系电话</span>
        <input type="text" placeholder="请输入手机号" v-model="param.phone" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">邮寄地址</span>
        <input type="text" placeholder="请输入收件地址" v-model="param.ship_to" />
      </div>
      <div class="item">
        <span class="star" :class="selectStatus == '个人'?'opacity':''">*</span>
        <span class="title">电子邮箱</span>
        <input type="text" placeholder="请输入电子邮箱" v-model="param.email" />
      </div>
      <div class="item">
        <span class="star" style="opacity:0">*</span>
        <span class="title">备注</span>
        <input type="text" placeholder="简要描述您的问题" v-model="param.memo" />
      </div>
    </div>
    <div class="box" v-show="selectType == 1">
      <div class="item">
        <span class="star">*</span>
        <span class="title">企业名称</span>
        <input type="text" placeholder="请输入企业名称" v-model="param.bill_to" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">税号</span>
        <input type="text" placeholder="请输入纳税人识别号" v-model="param.tfn" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">企业地址</span>
        <input type="text" placeholder="请输入企业地址" v-model="param.company_add" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">企业电话</span>
        <input type="text" placeholder="请输入企业联系方式" v-model="param.company_tel" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">开户银行</span>
        <input type="text" placeholder="请输入开户行" v-model="param.bank_name" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">银行账号</span>
        <input type="text" placeholder="请输入账号" v-model="param.bank_account" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">学员姓名</span>
        <input type="text" placeholder="请输入学员姓名" v-model="param.student_name" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">联系人</span>
        <input type="text" placeholder="请输入联系人姓名" v-model="param.contact" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">联系电话</span>
        <input type="text" placeholder="请输入手机号" v-model="param.phone" />
      </div>
      <div class="item">
        <span class="star">*</span>
        <span class="title">邮寄地址</span>
        <input type="text" placeholder="请输入收件地址" v-model="param.ship_to" />
      </div>
      <div class="item">
        <span class="star" style="opacity:0">*</span>
        <span class="title">备注</span>
        <input type="text" placeholder="简要描述您的问题" v-model="param.memo" />
      </div>

    </div>

    <button class="addApply" @click="addApply">提交申请</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      checked: true,
      checked2: false,
      selectType: 0,
      selectStatus: "个人",
      param: {
        id:null,
        sign_id: null,
        bill_to: "", //（学员姓名，或企业名称）
        contact: "", //非必选，string，联系人（仅企业类型抬头普票和专票需要）
        tfn: "", //非必选，string，税号（仅企业类型抬头普票和专票需要）
        phone: "", //必选，string，联系电话
        email: "", //非必选，string，电子邮箱
        company_add: "", //非必选，string，企业地址（仅专票需要）
        company_tel: "", //非必选，string，企业电话（仅专票需要）
        bank_name: "", //非必选，string，开户银行（仅专票需要）
        bank_account: "", //非必选，string，银行账号（仅专票需要）
        ship_to: "", //非必选，string，邮寄地址（仅专票需要）
        memo: "", //非必选，string，备注
        student_name:"",//学员姓名（仅专票有意义）（新增）
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    select(e) {
      this.selectType = e;
    },
    handle() {
    },
    // 提交申请
    addApply() {
      this.param.is_company = this.selectStatus == "个人" ? 0 : 1
      this.param.invoice_type = this.selectType
      if(this.param.id){
        // 修改
        this.$http.updateInvoice(this.param).then(res=>{
          if (res.status == 1) {
            this.$hide.alert({
              message: res.msg
            }).then(()=>{
              this.$router.push({ path: "/" });
            });
          } else {
            this.$hide.alert({
              message: res.msg
            })
          }
        })
      }else{
        // 添加
        this.$http.invoice_apply(this.param).then(res => {
          if (res.status == 1) {
            this.$hide.alert({
              message: res.msg
            }).then(()=>{
              this.$router.go(-1)
            });
          } else {
            this.$hide.alert({
              message: res.msg
            })
          }
        });
      }
        
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let info = this.$route.params.info;
    if (!!info == true) {
      Object.keys(this.param).forEach(key => {
        this.param[key] = info[key];
      });
      this.selectStatus = info.is_company == 0 ? "个人" : "企业";
      this.selectType = info.invoice_type;
    } else {
      let id = this.$route.query.id;
      this.param.sign_id = id;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  background-color: #f6f6f6;
  .top {
    width: 100%;
    padding: 14px 17px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .hint {
      color: #999999;
      font-size: 13px;
    }
    .status {
      color: #377dff;
      font-size: 17px;
    }
  }
  .type {
    width: 100%;
    // height: 110px;
    background-color: #fff;
    padding: 11px 18px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    div {
      display: inline-block;
      flex: 1;
      text-align: center;
      border: 1px solid #c6c6c6;
      height: 60px;
      border-radius: 4px;
      .text_one {
        color: #7b7b7b;
        font-size: 16px;
        padding: 0;
        margin: 0;
        margin-top: 7px;
        margin-bottom: 4px;
      }
      .text_two {
        color: #7b7b7b;
        font-size: 13px;
        padding: 0;
        margin: 0;
      }
    }
    .putong {
      margin-right: 3%;
    }
    .light {
      border: 1px solid #377dff;
      .text_one,
      .text_two {
        color: #377dff;
      }
    }
  }
  .ticketHint {
    width: 100%;
    background-color: #fff;
    padding: 0px 18px 8px;
    margin: 0;
    box-sizing: border-box;
    font-size: 13px;
    color: #999999;
  }
  .hint_two {
    color: #999999;
    font-size: 13px;
    padding: 10px 17px;
    box-sizing: border-box;
  }
  .item {
    height: 51px;
    line-height: 51px;
    padding: 0 17px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 16px;
    border-bottom: 1px solid #f6f6f6;
    position: relative;
    .star {
      color: #f92d2d;
    }
    .title {
      color: #666666;
      margin-left: 2px;
      margin-right: 20px;
      display: inline-block;
      width: 70px;
    }
    input {
      border: none;
      height: 40px;
      display: inline-block;
      background-color: transparent;
    }
    .radio {
      //   height: 20px;
      vertical-align: middle;
    }
    .radio_one,
    .radio_two {
      vertical-align: middle;
      font-size: 15px;
    }
  }
  .addApply {
    width: 90%;
    height: 50px;
    line-height: 50px;
    background-color: #0e87f9;
    color: #fff;
    border: none;
    margin-top: 50px;
    border-radius: 39px;
    font-size: 18px;
    margin-left: 5%;
    margin-bottom: 50px;
  }
  input[type="radio"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }
  input[type="radio"] + label::before {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: text-bottom;
    border: 1px solid #d9d9d9;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    content: "";
  }
  input[type="radio"]:checked + label::before {
    background-color: #fff;
    background-clip: content-box;
    border-color: #79a0ff;
    border-width: 5px;
  }
  .opacity{
    opacity: 0 !important;
  }
}
</style>
<style>
.van-button--large {
  width: 90%;
  margin-left: 5%;
  margin-top: 30px;
}
</style>